import { useState, useCallback } from "react";
import { Box, Card, TextField, Button, Typography } from "@mui/material";
import globalApi from "../api/globalApi";

export default function PasswordGate({ onSuccess }) {
  const [value, setValue] = useState("");
  const [loading, setLoading] = useState(false);
  const [errorText, setErrorText] = useState("");

  const handleSubmit = useCallback(async () => {
    if (!value) {
      setErrorText("Vui lòng nhập mật khẩu");
      return;
    }
    setLoading(true);
    setErrorText("");
    try {
      const response = await globalApi.LoginDevPage(value);
      if (response.success) {
        onSuccess?.();
      } else {
        setErrorText(response.message);
      }
    } catch (e) {
      setErrorText("Mật khẩu không đúng hoặc có lỗi kết nối");
    } finally {
      setLoading(false);
    }
  }, [value, onSuccess]);

  const handleKeyDown = (e) => {
    if (e.key === "Enter") handleSubmit();
  };

  return (
    <Box
      sx={{
        flexGrow: 1,
        width: "100%",
        height: "100%",
        display: "grid",
        placeItems: "center",
        p: 2,
      }}
    >
      <Card
        sx={{
          width: "100%",
          maxWidth: 420,
          p: 3,
          display: "flex",
          flexDirection: "column",
          gap: 2,
        }}
      >
        <Typography variant="h6" fontWeight={700}>
          Nhập mật khẩu truy cập Dev
        </Typography>

        <TextField
          label="Mật khẩu"
          type="password"
          value={value}
          onChange={(e) => setValue(e.target.value)}
          onKeyDown={handleKeyDown}
          error={!!errorText}
          helperText={
            errorText || "Chỉ người được cấp quyền mới có thể truy cập."
          }
          autoFocus
        />
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Button
            variant="contained"
            onClick={handleSubmit}
            disabled={loading}
            sx={{ mt: 1 }}
          >
            {loading ? "Đang xác thực..." : "Đăng nhập"}
          </Button>
        </Box>
      </Card>
    </Box>
  );
}
